import React from "react";

import Backdrop from "../Backdrop";
import Spinner from "../Spinner";

const BackdropLoading = () => {
	return (
		<Backdrop open className="text-white">
			<Spinner color="inherit" />
		</Backdrop>
	);
};

export default BackdropLoading;
